// extracted by mini-css-extract-plugin
export default {"container":"style_container__NayiD","icon":"style_icon__LBX59"};